import Navbar from './Navbar';
import Footer from './Footer';
import BackToTop from './BackToTop';

function Layout({ children }) {
  return (
    <div className="app-shell">
      <Navbar />
      <main className="page-content">{children}</main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default Layout;
